import { ChangeDetectionStrategy, Component } from '@angular/core';
import { keys, toPairs } from '@sama/micro-dash';
import {
  absoluteFromRelativeUrl,
  projectTaskPath,
} from '../../../cross-team-shared/hub-paths';
import { BrowserControlService } from '../../../cross-team-shared/misc-services/browser-control.service';
import { EventTrackingService } from '../../../shared/event-tracking/event-tracking.service';
import { TaskWorkspaceStore } from '../../h3ml/state/task-workspace-store';

@Component({
  selector: 'h3-task-id',
  templateUrl: './task-id.component.html',
  styleUrls: ['./task-id.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TaskIdComponent {
  taskId$ = this.store('task')('id').$;

  constructor(
    private store: TaskWorkspaceStore,
    private eventTrackingService: EventTrackingService,
    private browserControlService: BrowserControlService,
  ) {}

  copyTaskUrl() {
    this.eventTrackingService.track({
      id: 'copy_task_url',
      bucket: 'navigation',
      sub_bucket: 'page',
    });

    void this.browserControlService.writeClipboardText(this.getTaskUrl());
  }

  private getTaskUrl() {
    const { project, task } = this.store.state();
    const absoluteUrl = absoluteFromRelativeUrl(projectTaskPath(project, task));

    const fusions = this.store.state().fusions;
    const fusionOutputIds = keys(fusions);

    // there is one fusion output id per sensor fusion / single annotation
    // output, it doesn't make sense to have initial values when we don't know
    // which output it applies to
    if (fusionOutputIds.length !== 1) {
      return absoluteUrl;
    }

    // fusions in the store is a StrictRecord<number, FusionState> but getting
    // the keys with keys() converts them to string
    const outputId = Number(fusionOutputIds[0]);
    // @ts-ignore -- fix me
    const frameNumber = fusions[outputId].frameNumber.toString();
    const selectedShapes = toPairs(this.store('shapeSelection').state())
      // fix me if you change this code
      .filter(([_, selected]) => selected)
      .map(([shapeIndex]) => shapeIndex)
      .join(',');

    const url = new URL(absoluteUrl);
    url.search = new URLSearchParams({
      frameNumber,
      selectedShapes,
    }).toString();

    return url.toString();
  }
}
